import { Component, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewEncapsulation, NgZone, AfterViewInit } from '@angular/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { CalendarOptions, EventClickArg, EventApi, Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { NgbModal, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { helperService } from 'src/app/utils/helper';
import { TkAvailabilityService } from '../tk-availability/tk-availability/tk-availability.service';
import { TimeKeeperDashboardService } from './time-keeper-dashboard.service';

@Component({
    selector: 'app-timekeeper-dashboard',
    templateUrl: './timekeeper-dashboard.component.html',
    styleUrls: ['./timekeeper-dashboard.component.scss'],
    providers: [DecimalPipe],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TimekeeperDashboardComponent implements OnInit, AfterViewInit {
  @ViewChild("calendar", { static: false })
  calendarComponent!: FullCalendarComponent;
  breadCrumbItems!: Array<{}>;
  events: any = [];
  isWidgetsLoading:Boolean=false;
  isLoading:Boolean=false;
  date: any;
  start: any;
  end: any;
  formEditData!: UntypedFormGroup;
  editEvent: any;
  currentEvents: EventApi[] = [];
  dateSelected: any;
  calendar!: Calendar;

  chartConfigs: any[]=[{
    chartType:"Advanced Pie Chart",
    chartId:1,
    chartName:"Open Task Due Date Pie Chart",
    data:[],
    colorScheme:{
      domain:  ['green', 'yellow', 'orange', 'red']
    },
    view: [900, 250],
    animations: true
  }]
  widgetDialog: Boolean = false;

  @ViewChild('editmodalShow') editmodalShow!: TemplateRef<any>;

  
  calendarOptions: CalendarOptions = {
    plugins: [dayGridPlugin, interactionPlugin],
    headerToolbar: {
      left: 'prevYear,prev',
      center: 'title',
      right: 'today,next,nextYear'
    },
    initialView: "dayGridWeek",
    firstDay: 0,
    themeSystem: "bootstrap",
    initialEvents: this.events,
    eventContent: this.customEventContent.bind(this),
    datesSet: this.handleMonthChange.bind(this),
    weekends: true,
    editable: false,
    selectable: true,
    selectMirror: false,
    dayMaxEvents: false,
    contentHeight: 'auto'
  };
  private taskLoadingSubscription: any;

  
  constructor(
    private availablityService: TkAvailabilityService, 
    private modalService: NgbModal, 
    private formBuilder: UntypedFormBuilder, 
    private filterService: helperService, 
    private tkDashboardService: TimeKeeperDashboardService,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    // BreadCrumb 
    this.breadCrumbItems = [
      { label: 'Dashboard' },
      { label: 'Dashboard', active: true }
    ];
  }

  ngAfterViewInit(): void {
    // Run potentially state-changing operations after view init and outside Angular zone
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.ngZone.run(() => { 
          console.log('Initializing calendar and loading data... in ngAfterViewInit');
          // Init calendar options and load data
          this.loadAvailabilityList(this.start, this.end);
        });
      });
    });
  }

  
  onSelect(data:any): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data:any): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data:any): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

  async handleMonthChange(payload: any) {
    this.setCalendarOptions([]);
    let start = this.filterService.convertDateToFormattedStr(payload.view.currentStart)
    let end = this.filterService.convertDateToFormattedStr(payload.view.currentEnd)
    console.log('Calendar month changed. New start:', start, 'New end:', end);
    this.loadAvailabilityList(start, end);

  }
   loadAvailabilityList(start: any, end: any) {
    this.start = start ? start : this.start;
    this.end = end ? end : this.end;
    this.isLoading = true;
    console.log('Loading availability list for period:', this.start, 'to', this.end);
    if (this.taskLoadingSubscription)
      this.taskLoadingSubscription.unsubscribe();
    this.taskLoadingSubscription = this.availablityService.getAllAvailabilityList(start, end, null).subscribe({
      next: res => {
        let list: any = [];
        res.data.forEach((element: any) => {
          if (element.away == "Yes") {
            list.push({ title: "Not Available", date: element.availableDate, allDay: true, color: '#c97c7c', order: 5 });
          } else {
            if (element.morningSlot > 0) {
              list.push({ title: "Morning", date: element.availableDate, color: '#3d82b9', availableTimeValue: element.morningSlot, order: 1 });
            }
            if (element.afternoonSlot > 0) {
              list.push({ title: "Afternoon", date: element.availableDate, color: '#3d82b9', availableTimeValue: element.afternoonSlot, order: 2 });
            }
            if (element.eveningSlot > 0) {
              list.push({ title: "Evening", date: element.availableDate, color: '#3d82b9', availableTimeValue: element.eveningSlot, order: 3 });
            }
            if (element.morningSlot > 0 || element.afternoonSlot > 0 || element.eveningSlot > 0)
              list.push({
                title: "Total Availability",
                date: element.availableDate,
                color: '#5c9f5c',
                availableTimeValue: Number(element.morningSlot) + Number(element.afternoonSlot) + Number(element.eveningSlot),
                order: 4
              });
          }
        });
        this.events = list;
        this.setCalendarOptions(list);
        this.isLoading = false;
      },
      error: err => {
        console.error('Error fetching availability list:', err);
        this.isLoading = false;
        // Optionally, show a user-friendly error message here
      }
    });
  }
  customEventContent(arg: any) {
    //add time
    let timeText = document.createElement('span')

    if (arg.event.extendedProps.availableTimeValue) {
      timeText.className = "fc-event-time";
      timeText.innerHTML = this.getTimeKey(arg.event.extendedProps.availableTimeValue);

    }
    //include additional info
    let additionalText = document.createElement('i')
    additionalText.className = "fc-event-title";
    additionalText.innerHTML = arg.event.title;

    let arrayOfDomNodes = [timeText, additionalText]
    return { domNodes: arrayOfDomNodes }
  }
  getTimeKey(time: any) {
    return this.filterService.convertTimeNumToStr(time);
  }


  onAvailabilityChange(event: any) {
    let year = this.date.getFullYear();
    let month = this.date.getMonth() + 1 <= 9 ? '0' + (this.date.getMonth() + 1) : (this.date.getMonth() + 1);
    let day = this.date.getDate() <= 9 ? '0' + this.date.getDate() : this.date.getDate();
    let finalDate = year + "-" + month + "-" + day;
    let calendarApi = this.calendarComponent.getApi();
    calendarApi.gotoDate(finalDate);
  }
  setCalendarOptions(list: any) {
    this.calendarOptions.events = [];
    this.calendarOptions = {
      plugins: [dayGridPlugin, interactionPlugin],
      headerToolbar: {
        left: 'prevYear,prev',
        center: 'title',
        right: 'today,next,nextYear'
      },
      initialView: "dayGridWeek",
      eventOrder: "order",
      firstDay: 1,
      themeSystem: "bootstrap",
      events: list,
      eventContent: this.customEventContent.bind(this),
      datesSet: this.handleMonthChange.bind(this),
      weekends: false,
      editable: false,
      selectable: true,
      selectMirror: false,
      dayMaxEvents: false,
      contentHeight: 'auto'
    };
    this.isLoading=false;

  }

  handleEvents(events: EventApi[]) {
    this.currentEvents = events;
  }

  handleEventClick(clickInfo: EventClickArg) {
    this.editEvent = clickInfo.event;
    this.formEditData = this.formBuilder.group({
      editTitle: clickInfo.event.title,
      editCategory: clickInfo.event.classNames[0],
    });
    this.modalService.open(this.editmodalShow, { centered: true });
  }

  openWidgetModal():any{
    this.widgetDialog=true;
  }

  closeDialog() {
    this.widgetDialog = false;
  }

}
